type ExternalEvent = {
	id?: string;
	iCalUId?: string;
	upsalesId?: string | number;
	startDateTime: string;
	endDateTime: string;
};

type EditedAppointment = {
	id?: number;
	externalCalendarId?: string | null;
	uniqueExternalId?: string | null;
};

/**
 * Whether an event from someone's calendar is the meeting we are editing.
 *
 * Which id can tell depends on whose calendar it came from. Only the booker holds the event
 * we exported, so only they can match on the appointment's externalCalendarId, or on the
 * upsalesId the calendar app stamps on it — which arrives as a string. Every other
 * participant holds their own copy of the same meeting, and all those copies share is the
 * iCalUId that the import path stores on the appointment as uniqueExternalId.
 */
const isThisAppointment = (event: ExternalEvent, appointment: EditedAppointment) =>
	Boolean(
		(appointment.id && `${appointment.id}` === `${event.upsalesId}`) ||
			(event.id && event.id === appointment.externalCalendarId) ||
			(event.iCalUId && event.iCalUId === appointment.uniqueExternalId)
	);

/**
 * The events left once every calendar's copy of the meeting being edited is removed. A
 * meeting does not conflict with itself, and the availability views draw it from the
 * appointment we are editing rather than from the calendars it was synced to.
 */
export const withoutThisAppointment = (events: ExternalEvent[] = [], appointment: EditedAppointment) =>
	events.filter(event => !isThisAppointment(event, appointment));
